import React, { FC } from 'react';

type Props = {
  tag: string;
  id: string;
  onClick: (id: string) => void;
};

export const SelectionTag: FC<Props> = ({ tag, id, onClick }) => {
  return (
    <button
      className="flex  flex-row items-center hover:cursor-pointer my-1 mx-1 text-sm bg-primary py-1 px-3 rounded-full w-auto top-1 "
      onClick={() => onClick(id)}
    >
      <span className="text-white text-nowrap">{tag}</span>
    </button>
  );
};
